import { VpSticker } from '@vtmn-play/react'
import { VpLockIcon } from '@vtmn-play/icons/react'
import { getMyGameLanguage } from 'core/utils/i18n'
import { useTranslation } from 'react-i18next'

interface StoreTrajectoryValidatorProps {
  validatorUid?: string
  validationDate?: string
}

const StoreTrajectoryValidator = ({ validatorUid, validationDate }: StoreTrajectoryValidatorProps) => {
  const { t } = useTranslation()

  const formatValidationDate = (value: string) => {
    return new Intl.DateTimeFormat(getMyGameLanguage(), {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    }).format(new Date(value))
  }

  return (
    validatorUid &&
    validationDate && (
      <VpSticker {...({ variant: 'catchy', size: 'small' } as any)} className="mg-store-trajectory-validator vp-body-s">
        <VpLockIcon {...({ size: 20 } as any)} />
        {t('general.trajectory.store.validated', {
          validatorUid,
          validationDate: formatValidationDate(validationDate)
        })}
      </VpSticker>
    )
  )
}

export default StoreTrajectoryValidator
